/*
 * sht-anmb-countdown
 * Lightweight, flicker-free countdown for the announcement bar (Rock am Ring style).
 * Renders plain, always zero-padded two-digit numbers — no flip animation.
 */
(function () {
  if (window.customElements && customElements.get('sht-anmb-countdown')) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  class AnmbCountdown extends HTMLElement {
    connectedCallback() {
      this.hideOnEnd = this.getAttribute('data-hide-on-end') === 'true';

      var date = this.getAttribute('data-end-date');
      var time = this.getAttribute('data-end-time') || '23:59:00';
      if (time.length === 5) time += ':00';

      var off = this.getAttribute('data-tz-offset') || '+0000';
      var sign = off.charAt(0) === '-' ? -1 : 1;
      var offMs =
        sign *
        (parseInt(off.substr(1, 2), 10) * 60 + parseInt(off.substr(3, 2), 10)) *
        60000;

      var wallUTC = Date.parse(date + 'T' + time + 'Z');
      this.target = isNaN(wallUTC) ? null : wallUTC - offMs;

      this.numDays = this.querySelector('[data-days]');
      this.numHours = this.querySelector('[data-hours]');
      this.numMins = this.querySelector('[data-mins]');
      this.numSecs = this.querySelector('[data-secs]');
      this.timerEl = this.querySelector('.anmb-cd__pill');
      this.msgEl = this.querySelector('.anmb-cd__msg');

      if (this.target === null) return;

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      var rem = this.target - Date.now();
      if (rem <= 0) {
        if (this.interval) clearInterval(this.interval);
        this.set(0, 0, 0, 0);
        if (this.msgEl && this.msgEl.innerHTML.trim() !== '') {
          this.msgEl.classList.remove('d-none');
        }
        if (this.hideOnEnd && this.timerEl) {
          this.timerEl.classList.add('d-none');
        }
        return;
      }
      this.set(
        Math.floor(rem / 86400000),
        Math.floor((rem % 86400000) / 3600000),
        Math.floor((rem % 3600000) / 60000),
        Math.floor((rem % 60000) / 1000)
      );
    }

    set(d, h, m, s) {
      if (this.numDays) this.numDays.textContent = pad(d);
      if (this.numHours) this.numHours.textContent = pad(h);
      if (this.numMins) this.numMins.textContent = pad(m);
      if (this.numSecs) this.numSecs.textContent = pad(s);
    }
  }

  customElements.define('sht-anmb-countdown', AnmbCountdown);
})();
